export enum TipoDocumento{
    DNI = 96,
    CUIT = 80,
    CUIL = 86,
    Extranjero = 1
}